module.exports = {"BASE_URL":"https://d1.famikit.com","STS_URL":"https://d1.famikit.com/MDM/GetIcon","OSS_URL":"http://oss-us-west-1.aliyuncs.com/","OSS_BUCKET":"famikit-1","IS_DEMO":true}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1